import React, {Component} from 'react';
import '../../../../styles/sidebar.css';
import {toast, ToastContainer} from 'react-toastify';
import {Link} from 'react-router-dom';
import {ROUTE_DASHBOARD_LOGOUT} from '../../../../constants/routes/routes-ui';

import {Drawer} from '@material-ui/core'
import {MENU} from '../../../../constants/app/menu'
import logo from '../../../../images/logo-menu.svg';
import ModalGetReport from '../inspection/components/getReport/get-report-inspections';
import {STATUS_SERVICE} from '../../../../constants/app/services'
import InspectionApi from '../../../../api/inspection';
import Download from '@axetroy/react-download';
import {MESSAGES_NOTIFY, CONFIG_NOTIFY} from '../../../../constants/app/inspection'

class SidebarApp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            date: {
                dateEnd: '',
                dateStart: ''
            },
            urlAux: {
                keyName: ''
            },
            getUrl: false,
            isDisabled: true
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 1);
    }

    componentDidUpdate() {
        const {urlAux, date, getUrl} = this.state;
        let dateBodyReset = {
            dateEnd: '',
            dateStart: ''
        };
        if (this.props.statusReport === STATUS_SERVICE.ERROR) {
            toast.error(MESSAGES_NOTIFY.MESSAGE_TO_GET_REPORT_INSPECTIONS_ERROR, CONFIG_NOTIFY);
            this.props.getReportInspectionReset();
        }
        if (this.props.statusReport === STATUS_SERVICE.SUCCESS) {
            this.setState({urlAux: this.props.url, getUrl: true})
            this.props.getReportInspectionReset();
        }
    }

    getReportFile = () => {
        const dateBodyReset = {
            dateEnd: '',
            dateStart: ''
        };
        this.setState({openModal: false, date: dateBodyReset, getUrl: false, isDisabled: true, urlAux: {}}, () => {
            this.props.getReportInspectionReset();
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_GET_REPORT_INSPECTIONS, CONFIG_NOTIFY);
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({nextProps});
    }

    logout = (e) => {
        this.props.toggleDrawer();
        this.props.logout();
        e.preventDefault();
    }
    openModalReport = () => {
        const {openModal, urlAux} = this.state;
        if (openModal) {
            let dateBodyReset = {
                dateEnd: '',
                dateStart: ''
            };
            const urlReset = {
                keyName: ''
            };
            this.setState({date: dateBodyReset, isDisabled: true, urlAux: urlReset, getUrl: false});
        }
        this.setState({openModal: !openModal}, () => {
            this.props.toggleDrawer();
        })
    }
    getReport = () => {
        const {date} = this.state;

        if (date.dateStart.length === 0 || date.dateEnd.length === 0) {
            return toast.warning('Debe seleccionar ambas fechas para generar el reporte.', CONFIG_NOTIFY);
        } else {
            const auxEnd = date.dateEnd.split("-");
            const auxStart = date.dateStart.split("-");
            auxStart.reverse();
            auxEnd.reverse();
            let dateBody = {
                dateEnd: auxEnd.join("/"),
                dateStart: auxStart.join("/"),
            }
            this.props.getReportInspection(dateBody)
        }
    }
    handleDate = (e) => {
        const {date} = this.state;

        if (e.target.value && e.target.value.length) {
            const aux = {...date};
            const transform = e.target.value;
            aux[e.target.id] = transform;
            this.setState({date: aux});
            if (aux.dateStart.length > 0 && aux.dateEnd.length > 0) {
                this.setState({getUrl: false, isDisabled: false});
            }
        }
    }
    renderFooter = () => {
        const {user} = this.props;
        const userFullName = `${user.names} ${user.firstSurname} ${user.lastSurname}`;

        return (
            <footer>
                <div className="text-lg text-capitalize">{userFullName}</div>
                <div className="close-session">
                    <Link to={ROUTE_DASHBOARD_LOGOUT} onClick={this.logout}>
                        <span className="icon-logout icon-24 text-md--blue"/>
                        <span className="text-md--blue text">Cerrar sesión</span>
                    </Link>
                </div>
            </footer>
        );
    }

    renderMenuItem = ({link, isModal, className, label}, index) => {
        if (!link && isModal) {
            return (
                <li key={`menu-item-${index}`} onClick={this.openModalReport}>
                    <span className="h2" id={`menu-item-${index}`}>{label}</span>
                </li>
            )
        }
        return (
            <li key={`menu-item-${index}`}>
                <Link to={link} className={className} onClick={this.props.toggleDrawer}>
                    <span className="h2">{label}</span>
                </Link>
            </li>
        )
    };

    render() {
        const {openModal, date, getUrl, urlAux, isDisabled} = this.state;
        const {toggleDrawer, open, url, statusReport, isViewer} = this.props;
        return (
            <div>
                <Drawer open={open} onClose={toggleDrawer}>
                    <div className="containerDrawer">
                        <nav className="menu">
                            <div className="menu-logo">
                                <img src={logo} width="90%" alt=""/>
                            </div>
                            <ul>{isViewer ? MENU.slice(0, 1).map(this.renderMenuItem) : MENU.map(this.renderMenuItem)}</ul>

                            {this.renderFooter()}
                        </nav>
                    </div>
                </Drawer>
                <ToastContainer/>
                <ModalGetReport open={openModal} handleClose={this.openModalReport} handleOk={this.getReport}
                                handleDate={this.handleDate} date={date} urlFile={urlAux} getUrl={getUrl}
                                isDisabled={isDisabled} statusReport={statusReport} getReportFile={this.getReportFile}/>
            </div>
        )
    }
}

export default SidebarApp;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/chunks/sidebar.js